import { constants, mappings } from '../';

const getVariant = instantBooking =>
  instantBooking ? 'instant_booking' : 'regular_booking';

export const mapListingToProduct = listing => {
  const {
    type,
    id,
    cityId,
    pricing,
    instantBooking: { isEnabled },
    minimumPrice
  } = listing;
  return {
    category: type,
    id,
    name: `Listing with id ${id} in ${cityId}`,
    price: pricing.price || minimumPrice,
    variant: getVariant(isEnabled),
    list: constants.TRACKING_PAGE_TYPES.PRODUCT_PAGE
  };
};

export const mapSearchPageHomecardToProduct = (homecard, position, cityId) => {
  const { type, id, monthlyPrice, isInstantBooking } = homecard;
  return {
    category: mappings.mapHomecardTypeToProductCategory(type),
    id,
    name: `Listing with id ${id} in ${cityId}`,
    price: monthlyPrice.minimumPrice,
    variant: getVariant(isInstantBooking),
    list: constants.TRACKING_PAGE_TYPES.SEARCH_PAGE,
    position: position + 1
  };
};

export const mapExtraRoomsToProduct = (listing, mainListing, position) => {
  const { id, monthlyPrice } = listing;
  const {
    type,
    instantBooking: { isEnabled },
    cityId
  } = mainListing;
  return {
    category: type,
    id,
    name: `Listing with id ${id} in ${cityId}`,
    price: monthlyPrice.minimumPrice,
    variant: getVariant(isEnabled),
    list: constants.LIST_E_COMMERCE.EXTRA_ROOMS,
    position: position + 1
  };
};

export const mapSimilarPropertyToProduct = (similarProperty, position) => {
  const {
    type,
    id,
    city,
    monthlyPrice,
    instantBooking: { isEnabled }
  } = similarProperty;
  return {
    category: mappings.mapHomecardTypeToProductCategory(type),
    id,
    name: `Listing with id ${id} in ${city}`,
    price: monthlyPrice.minimumPrice,
    variant: getVariant(isEnabled),
    list: constants.LIST_E_COMMERCE.SIMILAR_PROPERTIES,
    position: position + 1
  };
};

export const mapFavoriteToProduct = (favorite, position) => {
  const { type, id, city, monthlyPrice, isInstantBooking } = favorite;
  return {
    category: type,
    id,
    name: `Listing with id ${id} in ${city}`,
    price: monthlyPrice.minimumPrice,
    variant: getVariant(isInstantBooking),
    list: constants.TRACKING_PAGE_TYPES.FAVORITES,
    position: position + 1
  };
};

export const mapExtraRoomToCd = (extraRoom, mainListing, isLogged, locale) => {
  try {
    return {
      ...extraRoom,
      listing: {
        ...mainListing,
        ...extraRoom
      },
      isLogged,
      locale,
      pageType: constants.TRACKING_PAGE_TYPES.PRODUCT_PAGE
    };
  } catch (err) {
    return console.error('Failed to map extra room to cd', { err });
  }
};

export const mapSimilarPropertyToCd = (homecard, isLogged, locale) => {
  try {
    const { instantBooking, monthlyPrice, city } = homecard;
    return {
      listing: {
        ...homecard,
        instantBooking: instantBooking.isEnabled,
        reservationPrice: monthlyPrice.minimumPrice,
        cityId: city,
        type: mappings.mapHomecardTypeToProductCategory(homecard.type)
      },
      isLogged,
      locale,
      pageType: constants.TRACKING_PAGE_TYPES.PRODUCT_PAGE
    };
  } catch (err) {
    return console.error('Failed to map similar property to cd', { err });
  }
};

export const mapFavoriteToCd = (favorite, locale) => {
  try {
    return {
      ...favorite,
      cityId: favorite.city,
      isLogged: true,
      locale,
      pageType: constants.TRACKING_PAGE_TYPES.FAVORITES
    };
  } catch (err) {
    return console.error('Failed to map favorite to cd', { err });
  }
};

export const mapBookNowButtonToECommerce = props => {
  try {
    const {
      pricing: { pricing },
      listing,
      unavailabilities,
      moveIn,
      moveOut
    } = props;
    return {
      ...listing,
      minimumPrice: listing.pricing.monthlyPrice.minimumPrice,
      pricing,
      moveIn,
      moveOut,
      unavailabilities,
      currencyCode: pricing.currencyCode,
      reservationPrice: pricing.monthlyPrice,
      tenantFeeGross: pricing.tenantFeeGross,
      totalContractValue: pricing.totalContractValue,
      quantity: 1
    };
  } catch (err) {
    return console.error('Failed to map bookNow to ecommerce', { err });
  }
};
